module.exports = require('./helpers/bundle-url').getBundleURL('dQMqr') + "logo.c51670a8.svg";